import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import classNames from 'classnames'

type InputProps = JSX.IntrinsicElements['input']

type Props = InputProps & {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  formSize?: 'xsmall' | 'medium'
}

const DatePicker: FC<Props> = (props) => {
  const { disabled, max, min, onChange, formSize = 'medium', step, type = 'date', value } = props

  return (
    <label
      className={classNames({
        [styles.datetime__wrapper]: formSize !== 'xsmall',
        [styles.datetime__wrapper_xsmall]: formSize === 'xsmall',
      })}
    >
      <input
        className={classNames({
          [styles.datetime]: formSize !== 'xsmall',
          [styles.datetime_xsmall]: formSize === 'xsmall',
        })}
        disabled={disabled}
        max={max}
        min={min}
        onChange={(e) => onChange(e)}
        step={step}
        type={type}
        value={value}
      />
      <span
        className={classNames({
          [styles.triangle]: formSize !== 'xsmall',
          [styles.triangle_xsmall]: formSize === 'xsmall',
        })}
      />
      <span
        className={classNames({
          [styles.triangle_inverted]: formSize !== 'xsmall',
          [styles.triangle_inverted_xsmall]: formSize === 'xsmall',
        })}
      />
    </label>
  )
}

export default DatePicker
